import { getTelLinkFromPhone } from "./utils/getTelLinkFromPhone";

export const menu = [
  {
    text: "Início",
    to: "/",
  },
  {
    text: "Imóveis",
    to: "/imoveis",
  },
  {
    text: "Sobre",
    to: "/sobre",
  },
  {
    text: "Contato",
    to: "/contato",
  },
];

export function getSocial(component) {
  if (!component.$rest) throw new Error();

  const social = [];

  if (component.informations.facebook)
    social.push({
      title: "Facebook",
      link: component.informations.facebook,
      icon: "fab fa-facebook-f",
      size: 18,
    });
  if (component.informations.instagram)
    social.push({
      title: "Instagram",
      link: component.informations.instagram,
      icon: "fab fa-instagram",
      size: 18,
    });
  if (component.informations.whatsapp)
    social.push({
      title: "WhatsApp",
      link: component.informations.whatsapp,
      icon: "fab fa-whatsapp",
      size: 18,
    });

  return social;
}

export function getWhatsappLink(component) {
  if (!component.informations || !component.informations.whatsapp) return "";
  return component.informations.whatsapp;
}

export function getContact(component) {
  const contact = [];

  if (component.informations.address)
    contact.push({
      text: component.informations.address,
      link: component.informations.google_maps
        ? component.informations.google_maps
        : "",
      target: "_blank",
      icon: "fa-map-marker-alt",
    });
  if (component.informations.tel)
    contact.push({
      text: component.informations.tel,
      link: getTelLinkFromPhone(component.informations.tel),
      target: "_self",
      icon: "fa-phone-alt",
    });
  if (component.informations.email)
    contact.push({
      text: component.informations.email,
      link: "mailto:" + component.informations.email,
      target: "_self",
      icon: "fa-envelope",
    });

  return contact;
}
